import * as Yup from 'yup';
export const initialGrantValues = {
    description: '',
    enumId: '',
};
export const grantSchema = Yup.object().shape({
    description: Yup.string(),
});
//# sourceMappingURL=grant.js.map